export const API_URL = import.meta.env.VITE_STEM_API_URL ?? "";

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export const getSessionId = (): string => {
  let sessionId = localStorage.getItem("stem_session_id");
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem("stem_session_id", sessionId);
  }
  return sessionId;
};

export const apiFetch = async (path: string, init: RequestInit = {}): Promise<Response> => {
  if (!API_URL) {
    throw new Error("VITE_STEM_API_URL is not set");
  }

  const res = await fetch(`${API_URL}${path}`, {
    ...init,
    headers: {
      "x-session-id": getSessionId(),
      ...(init.body && !(init.body instanceof FormData) ? { "Content-Type": "application/json" } : {}),
      ...init.headers,
    },
  });

  if (!res.ok) {
    let message = `Request failed: ${res.status}`;
    try {
      const body = await res.json();
      if (body?.error) message = body.error;
    } catch {
      // non-JSON error body — fall back to the status message
    }
    throw new ApiError(message, res.status);
  }

  return res;
};
